import React, { useMemo } from 'react';
import _keyBy from 'lodash/keyBy';

import LayoutSettingCard from 'molecules/LayoutSettingCard';

import { Field } from '@sift/types';
import * as Types from 'pages/Features/typings';
import * as FormValues from 'types/FormValue';
import parentFieldIsObjectArray from 'helpers/parentFieldIsObjectArray';
import isFieldValidConfigOption from 'helpers/isFieldValidConfigOption';

export const SORT_BY_SUBTITLE_COPY =
  'Select the attributes that are available to sort direct reports by on the org chart.';

interface Props {
  fields: Field[];
  values: Types.FeatureValues;
  userStatus: number;
  onChange: (field: string, value: FormValues.FormValue) => void;
}

function sortableAttributesFilter(field: Field, fields: Field[]) {
  const VALID_FIELD_TYPES = ['text', 'textSelect', 'boolean', 'number', 'date'];

  return (
    VALID_FIELD_TYPES.includes(field.type) &&
    isFieldValidConfigOption(field, { whitelistObjectKeys: ['timezoneAndWorkHours.timezone'] }) &&
    !parentFieldIsObjectArray(field, fields)
  );
}

function SortableAttributes({ fields, values, userStatus, onChange }: Props) {
  const keyedFields = useMemo(() => _keyBy(fields, 'objectKey'), [fields]);

  return (
    <LayoutSettingCard
      cardTitle="Sortable Attributes"
      dialogTitle="Sortable Attributes"
      subtitle={SORT_BY_SUBTITLE_COPY}
      filter={field => sortableAttributesFilter(field, fields)}
      fields={keyedFields}
      layoutKey="org-chart-sortable-attributes"
      userStatus={userStatus}
      values={values}
      typeKey="user"
      onChange={onChange}
    />
  );
}

export default SortableAttributes;
